import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取提现记录 **/
    GET_WALLET_LIST(data) {
        controller='EsWallet';
        action='GetWalletList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 提现失败 **/
    CANNEL_WALLET(data) {
        controller='EsWallet';
        action='CannelWallet';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 提现成功 **/
    SUCCESS_WALLET(data) {
        controller='EsWallet';
        action='SuccessWallet';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 提现状态 **/
    WALLET_STATUS(data) {
        controller='EsWallet';
        action='GetWalletStatus';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 上传凭证 **/
    SAVE_PHOTOS(data) {
        controller='EsWallet';
        action='UploadWallet';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取待审核的订单数量、金额 **/
    GET_WALLET_COUNT(data) {
        controller='EsWallet';
        action='GetWalletCount';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data });
    },
   
}